"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _useEventListener = _interopRequireDefault(require("../useEventListener"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var useOutsideClick = function useOutsideClick(target, handler) {
  var onEvent = (0, _react.useCallback)(function (event) {
    var targetElement = target.current;
    var clickedElement = event === null || event === void 0 ? void 0 : event.target;
    if (targetElement && targetElement !== clickedElement && !targetElement.contains(clickedElement)) {
      handler(event);
    }
  }, [handler, target]);
  (0, _useEventListener.default)('mousedown', onEvent);
  (0, _useEventListener.default)('touchend', onEvent);
};
var _default = useOutsideClick;
exports.default = _default;